var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9789 22.233V4.92773H33.1201V9.85566H23.2642V27.9247C23.2639 29.3711 22.7863 30.7769 21.9056 31.9242C21.0249 33.0715 19.7903 33.8961 18.3931 34.2702C16.996 34.6443 15.5145 34.547 14.1783 33.9933C12.8422 33.4396 11.726 32.4606 11.003 31.2079C10.2799 29.9552 9.99043 28.499 10.1793 27.0651C10.3682 25.6311 11.025 24.2996 12.0478 23.2769C13.0706 22.2542 14.4022 21.5976 15.8362 21.4089C17.2702 21.2201 18.7263 21.5098 19.9789 22.233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicFill);
export default __webpack_public_path__ + "static/media/music-fill.60281538c07ac7b660dabb67430d32a1.svg";
export { ForwardRef as ReactComponent };